import { AutoCenter, Image, Input, Toast } from "antd-mobile";
import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const SharePage: React.FC = (props: any) => {
  const [img, setImg] = useState<{
    width: number;
    height: number;
    url: string;
    input: any;
    btns: any[];
    title: string;
    download: string;
  }>();

  const { game } = useParams();
  const [code, setCode] = useState<string>();
  const [channel, setChannel] = useState<string>();
  useEffect(() => {
    const x1 = new URLSearchParams(location.search);
    setCode(x1.get("code") || "");
    axios
      .get("/api/shared", {
        params: {
          gameId: game,
          channel: x1.get("c") || "",
        },
      })
      .then((res: any) => {
        if (res.status != 200) {
          return;
        }

        const tmp = res.data.map;
        document.title = tmp.title;
        var x = window.window.outerWidth / tmp.width;
        if (x < 1) {
          let input = null;
          if (tmp?.input) {
            input = {
              top: tmp?.input.top * x,
              width: tmp?.input.width * x,
              height: tmp?.input.height * x,
              left: tmp?.input.left * x,
              fontSize: tmp?.input.fontSize * x,
            };
          }

          let btns = [] as any[];
          if (tmp?.btns) {
            tmp?.btns.forEach((e: any) => {
              btns.push({
                top: e.top * x,
                width: e.width * x,
                height: e.height * x,
                left: e.left * x,
                url: e.url,
                copy: e.copy,
              });
            });
          }
          setImg({
            width: window.window.outerWidth,
            height: tmp.height * x,
            url: tmp.url,
            input: input,
            btns: btns,
            title: tmp.title,
            download: tmp.download,
          });
        } else {
          setImg(tmp);
        }
      });
  }, []);

  const copyAction = (str: string) => {
    const createInput = document.createElement("input");
    createInput.value = str;
    document.body.appendChild(createInput);
    createInput.select();
    document.execCommand("Copy"); // document执行复制操作
    createInput.remove();
    Toast.show({
      content: "复制成功",
    });
  };

  const btns = img?.btns.map((e) => {
    if (e?.url && e?.url != "") {
      return (
        <img
          src={e?.url}
          style={{
            top: e?.top + "px",
            width: e?.width + "px",
            height: e?.height + "px",
            left: e?.left + "px",
            position: "absolute",
          }}
          key={e?.url}
          onClick={() => {
            console.log(e);
            if (e.copy == 1) {
              copyAction(code || "");
              return;
            }
            window.location.href = img.download;
          }}
        ></img>
      );
    }
  return null;
  });

  return (
    <div
      className="App"
      style={{
        position: "absolute",
        height: img?.height + "px",
        width: img?.width + "px",
        left: "0",
        top: "0",
        backgroundImage: img?.url,
        backgroundSize: "100%",
        backgroundRepeat: "no-repeat",
      }}
      onClick={() => {
        if (!img || img.btns.length > 0) {
          return;
        }
        window.location.href = img.download;
      }}
    >
      {img?.input && (
        <p
          style={{
            top: img?.input.top + "px",
            width: img?.input.width + "px",
            height: img?.input.height + "px",
            left: img?.input.left + "px",
            fontSize: img?.input.fontSize + "px",
            position: "absolute",
          }}
        >{code}</p>
      )}
      {btns}
    </div>
  );
};

export default SharePage;
